import { PartnershipFormTabs } from './PartnershipFormTabs';

type PartnershipFormProps = {
  className?: string;
  children: React.ReactNode;
};

const PartnershipFormRoot = ({ className, children }: PartnershipFormProps) => {
  return (
    <div className={`partnership-form ${className ?? ''}`.trim()}>
      {children}
    </div>
  );
};

const PartnershipForm = {
  Root: PartnershipFormRoot,
  Tabs: PartnershipFormTabs,
};

export { PartnershipForm, PartnershipFormRoot, PartnershipFormTabs };

export type { PartnershipFormProps };
